
import {
  IonPage, IonContent, IonProgressBar, loadingController,
  IonFooter, modalController, toastController, alertController,
  IonIcon, IonRippleEffect,
} from '@ionic/vue'
import {chevronForwardOutline} from 'ionicons/icons'
import {defineComponent, ref, watch, computed, onBeforeMount, onUpdated, nextTick} from 'vue'
import {useRouter, useRoute} from 'vue-router'
import {useStore} from 'vuex'
import contract from '@/components/Modal/Contract.vue'
import AddressInput from '@/components/Modal/AddressInput.vue'
import apiPartnership from '@/api/partnership'
import {SendBirdAction} from '@/plugins/SendBirdAction'
import useModal from '@/composables/useModal'
import channelApi from '@/api/open-channel'
import {AgButton} from '@/components/ag'
import {useGtm} from '@gtm-support/vue-gtm'
import {MODAL_OPEN_EVENT} from '@/plugins/gtm-event'

export default defineComponent({
  components: {
    AgButton,
    IonContent,
    IonFooter,
    IonIcon,
    IonPage,
    IonProgressBar,
    IonRippleEffect,
  },
  name: 'ClubDealJoin',
  props: {
    clubDealId: null,
  },
  setup(props) {
    const gtm = useGtm()
    const {sendNewMessage} = channelApi()
    const {useRegistEmailModal} = useModal()
    const {getters, dispatch} = useStore()
    const {getPartnershipsRequestProcess, isValidAddress, isValidEmail, isCertifyEmail, checkValidAsset} = apiPartnership()
    const partnershipId = computed(() => props.clubDealId)

    const router = useRouter()
    const route = useRoute()

    const partnershipName = ref('')
    const depositInfo = computed(() => getters['partnership/getDepositInfo'])

    function dismiss(id: string) {
      modalController.dismiss(null, '', id)
    }

    /* 매 프로세스에 공통으로 사용되는 변수 */
    const gauge = ref(0.25) // 상단 gauge
    const processStep = 6 // 협의 프로세스 단계 총 갯수
    const currentStep = ref(0) // 현재 단계
    const nextToggle = ref(false)
    const nextArray = ref(Array.from({length: 6}, () => false))

    /* checkbox 확인용 */
    const checkCount = ref(0)

    /* 약관동의 확인 용 */
    const confirmToggle = ref(false)
    const contractToggle = ref(false)
    const contractArray = ref(Array.from({length: 2}, () => false))

    /* 포인트 제어용 */
    const initPoint = computed(() => getters['pointInfo/getUserPoint'])
    const usePoint = ref(0)
    const currentPoint = computed(() => initPoint.value - usePoint.value)

    /* 출자 금액, 출자 금액 가능 범위, 출자 금액의 상태 */
    const investMoney = ref(0)
    const investMoneyStatus = ref('zero')
    const investRangeFrom = ref(0)
    const investRangeTo = ref(0)
    const stockPrice = ref(0)

    /* 주당 가격, 주식 수, 서비스 이용료 */
    const stockPerPrice = ref(0)
    const serviceFee = ref(0)
    const serviceFeeFlag = ref(false)
    const stockCount = computed(() => investMoney.value / stockPerPrice.value)
    const investmentContractSummaries = ref([])

    /* 최종 결정된 비용 */
    const finalPrice = computed(() => {
 return investMoney.value + serviceFee.value - usePoint.value
})
    const account = ref('')
    onBeforeMount(async () => {
      if (partnershipId.value) {
        await dispatch('pointInfo/loadData')
        const result = await getPartnershipsRequestProcess(Number(partnershipId.value))
        console.log(result)
        partnershipName.value = result.partnershipName
        investRangeFrom.value = result.availableAssetFrom
        investRangeTo.value = result.availableAssetTo
        stockPrice.value = result.purchasePrice
        stockPerPrice.value = result.purchasePrice
        serviceFee.value = result.serviceFeeAmount
        serviceFeeFlag.value = result.serviceFeeFlag
        account.value = `${result.bank} ${result.bankno} ${result.bankholder}`
        investmentContractSummaries.value = result.investmentContractSummaries
      }
    })

    watch(
      () => partnershipId.value,
      async newParams => {
        if (newParams.clubdealId) {
          await dispatch('pointInfo/loadData')
          const result = await getPartnershipsRequestProcess(Number(partnershipId.value))
          // console.log(result);
          partnershipName.value = result.partnershipName
          investRangeFrom.value = result.availableAssetFrom
          investRangeTo.value = result.availableAssetTo
          stockPrice.value = result.purchasePrice
          stockPerPrice.value = result.purchasePrice
          serviceFee.value = result.serviceFeeAmount
          serviceFeeFlag.value = result.serviceFeeFlag
          account.value = `${result.bank} ${result.bankno} ${result.bankholder}`
        }
      },
    )

    watch(partnershipName, () => {
      gtm?.trackEvent({
        event: MODAL_OPEN_EVENT,
        page: `${clickScreen}/${partnershipId.value}`,
        title: `${partnershipName.value} 참여 프로세스`,
      })
    })

    watch(investMoney, () => {
      if (investRangeFrom.value <= investMoney.value && investRangeTo.value >= investMoney.value) {
        investMoneyStatus.value = 'stable'
        nextToggle.value = true
        return
      } else if (investRangeFrom.value > investMoney.value) {
        investMoneyStatus.value = 'lack'
      } else if (investRangeTo.value < investMoney.value) {
        investMoneyStatus.value = 'over'
      } else {
        investMoneyStatus.value = 'zero'
      }
      nextToggle.value = false
    })

    function checkForm(e: any) {
      checkCount.value = e.checked ? checkCount.value + 1 : checkCount.value - 1
      // console.log(checkCount.value);
    }

    watch(checkCount, async () => {
      nextToggle.value = checkCount.value === 3
    })

    async function createModal(name?: string) {
      let modal: any = ''
      if (name === 'address') {
        modal = await modalController
          .create({
            backdropDismiss: true,
            component: AddressInput,
            cssClass: 'address-modal',
            id: 'AddressInput',
            keyboardClose: true,
            mode: 'ios',
            swipeToClose: true,
          })

        modal.onDidDismiss().then(() => {
          dispatch('user/ACT_SET_SETTING_INFO')
        })
      } else {
        modal = await modalController
          .create({
            backdropDismiss: true,
            component: contract,
            componentProps: {
              parent: clickScreen,
            },
            cssClass: 'full',
            id: 'ContractModal',
            keyboardClose: true,
            mode: 'ios',
            swipeToClose: true,
          })

        modal.onDidDismiss().then(() => {
          contractArray.value[1] = true
          contractToggle.value = true
        })
      }

      return modal.present()
    }

    async function openAlert() {
      const alert = await alertController
        .create({
          buttons: [
            {
              cssClass: 'btn-gray',
              handler: () => {
                // console.log('Confirm Cancel')
              },
              role: 'cancel',
              text: '취소',
            },
            {
              handler: () => {
                createModal('address')
              },
              text: '주소 입력',
            },
          ],
          cssClass: 'btn-groups adderss-alert-class',
          message: `
          <div class="alert_css">
            <div class="header">
            주소를 입력해주세요!
            </div>
            <div class="message">
              클럽딜 참여 후<br>
              조합규약 작성과 조합 설립을 위해<br>
              참여자님의 주소가 필요합니다.
            </div>
          </div>
          `,
        })
      return alert.present()
    }

    async function agreeFunc() {
      contractArray.value[0] = !contractArray.value[0]
      confirmToggle.value = !confirmToggle.value
      const result = await isValidAddress()

      if (!result) {
        await openAlert()
        contractArray.value[0] = !contractArray.value[0]
        confirmToggle.value = !confirmToggle.value
      } else {
        // console.log(result + '주소 입력 유효');
      }
    }

    watch(contractArray.value, async () => {
      let count = 0
      await contractArray.value.forEach(e => e ? count++ : '')
      nextToggle.value = count === contractArray.value.length
    })

    const requested = ref(false)

    async function nextProcess() {
      nextArray.value[currentStep.value] = nextToggle.value

      if (currentStep.value >= processStep) {
        return // maxStep보다 위에 있는 경우 (혹시 모를 에러 처리)
      }

      if (currentStep.value === 2) {
        const result = await isValidEmail()
        // console.log(result + '이메일 인증 성공');

        if (!result) {
          useRegistEmailModal()
          return
        }
      }

      if (currentStep.value === 5) {
        requested.value = true
        const loading = await loadingController
          .create({
            message: '출자 확정 중입니다.',
          })

        await loading.present()
        nextTick(() => {
          return dispatch('partnership/ACT_GET_DEPOSIT_BANKINFO',
            {
              investMoney: `${investMoney.value}`,
              partnershipId: `${partnershipId.value}`,
              usePoint: `${usePoint.value}`,
            })
        })
        // console.log(result);

        if (!depositInfo.value) {
          loading.dismiss()
          const toast = await toastController
            .create({
              duration: 1000,
              message: '출자 확정에 실패하였습니다.',
              position: 'middle',
            })
          return toast.present()
        }
          loading.dismiss()

      }

      currentStep.value += 1

      if (currentStep.value > 1 && currentStep.value !== 3) {
        gauge.value += 0.25
      }

      nextToggle.value = nextArray.value[currentStep.value]

      /* 스크롤 위로 이동! */
      const content: any = document.querySelector('#clubDealJoinIonContent')
      content.scrollToTop(0, 0)
    }

    function previousProcess() {
      if (currentStep.value === 0) {
        dismiss('clubDealJoinModal')
      }
      if (currentStep.value > 1 && currentStep.value !== 3) {
        gauge.value -= 0.25
      }
      currentStep.value -= 1
      nextToggle.value = nextArray.value[currentStep.value]
    }

    function addNumber(num: any) {
      const value: string = num.toString()
      let result: any = investMoney.value.toString()

      if (result.length >= 10) {
return result
}

      if ((value === '0' || value === '00') && result === '0') {
return
}

      result += value

      result = result.slice(0, 10)
      investMoney.value = Number(result)
    }

    function clearNumber() {
      let result: any = investMoney.value.toString()

      if (result === '') {
return
}

      result = result.slice(0, -1)

      investMoney.value = Number(result)
    }

    async function onSuccess() {
      // console.log('success')
      const toast = await toastController
        .create({
          duration: 1000,
          message: '계좌 번호가 복사되었습니다.',
          position: 'middle',
        })
      return toast.present()
    }

    async function onSuccessThen() {
      await onSuccess()
      await dispatch('partnership/ACT_GET_PARTNERSHIPS_REQUEST', partnershipId.value)
      await dismiss('clubDealJoinModal')
    }

    const textDiv = ref<any>(null)

    async function copyText(string: string, type: string) {
      const createInput = document.createElement('input')
      createInput.setAttribute('type', 'text')

      textDiv.value.append(createInput)
      createInput.value = string
      createInput.select()

      document.execCommand('copy')
      createInput.remove()

      if (type === 'copy') {
onSuccess()
} else if (type === 'quit') {
onSuccessThen()
}
    }

    async function onError() {
      // console.log('error')
    }

    const useAllPointToggle = ref(false)

    async function pointLimitInfo() {
      const alert = await alertController
        .create({
          buttons: ['확인'],
          cssClass: 'point-alert-class',
          message: `
            <div class="alert_css">
              <div class="alert-header">
                포인트는 10,000단위로<br/>
                사용이 가능합니다.
              </div>
            </div>`,
        })
      return alert.present()
    }

    async function adjustPoint(num: number, type?: string) {
      const total: any = finalPrice.value

      if (serviceFee.value < 10000) {
 await pointLimitInfo(); return
} // 사용료 10000P 이하는 포인트 사용 안됨
      if (type === 'all' && useAllPointToggle.value) {
return
} // 전액 사용을 이미 누른 경우에는 그냥 Return

      /* 포인트 전액 사용을 눌렀을 때 예외 처리 */
      if (type === 'all' && !useAllPointToggle.value) {
        useAllPointToggle.value = true

        if (num < 10000) {
 await pointLimitInfo(); return
}
        // 1. 보유 포인트가 10000p 이하인 경우 return
        if (num > serviceFee.value) {
 usePoint.value = serviceFee.value; return
}
        // 2. 보유 포인트가 서비스 이용료보다 많은 경우 = 서비스 이용료만큼만 사용하게 변경

        usePoint.value = Math.floor(num * 0.0001) * 10000
        // 3. 만단위로 숫자 절삭
        return
      }

      useAllPointToggle.value = false

      if (total < 0) {
return
}
      if (num > initPoint.value || num < 0 || num > serviceFee.value) {
return
}

      usePoint.value = num
    }

    const clickScreen = 'clubdeal-process'

    return {
      account,
      addNumber,
      adjustPoint,
      agreeFunc,
      checkCount,
      checkForm,
      chevronForwardOutline,
      clearNumber,
      clickScreen,
      confirm,
      confirmToggle,
      contractToggle,
      copyText,
      createModal,
      curPoint: currentPoint,
      curStep: currentStep,
      depositInfo,
      dismiss,
      finalPrice,
      gauge,
      initPoint,
      investMoney,
      investMoneyStatus,
      investRangeFrom,
      investRangeTo,
      investmentContractSummaries,
      nextProcess,
      nextToggle,
      onError,
      onSuccess,
      onSuccessThen,
      partnershipName,
      previousProcess,
      process,
      requested,
      route,
      router,
      serviceFee,
      stockCount,
      stockPerPrice,
      textDiv,
      usePoint,
    }
  },
})
